import { useEffect } from 'react';

import { Platform, PLATFORM_BODY_ATTR } from 'app-constants';
import UserDevice from 'services/user-device';

interface Output {
    platform: Platform;
}

const usePlatform = (): Output => {
    const platform = UserDevice.getInstance()?.isDeviceMobile()
        ? Platform.MOBILE
        : Platform.DESKTOP;

    useEffect(() => {
        document.body.setAttribute(PLATFORM_BODY_ATTR, platform);
    }, [platform]);

    return { platform };
};

export default usePlatform;
